import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationModel } from '../../shared/models/notification.model';
import { UiHelperService } from '../ui-helper/ui-helper.service';


@Injectable({
  providedIn: 'root'
})
export class MessageHeplerService {
  notification$ = new BehaviorSubject(new NotificationModel());

  constructor(private uihelper: UiHelperService) { }

  /**
   *
   *
   * Show success message
   *
   * @param detail
   */
  showSuccess({ message, viewCloseIcon, routeTo, routeToExternalLink, linkMessage }:
    { message: string; viewCloseIcon?: boolean; routeTo?: string; routeToExternalLink?: string; linkMessage?: string }): void {
    if (message) {
      this.notification$.next(new NotificationModel({
        message,
        class: 'showNoti',
        viewCloseIcon,
        routeTo,
        routeToExternalLink,
        linkMessage,
        viewNotification: true,
        type: 'success'
      }));
    }
  }

  /**
   *
   *
   * Show error message that is passed as parameter
   *
   * @param detail
   */
  showError({ message, viewCloseIcon, routeTo, routeToExternalLink, linkMessage }:
    { message: string; viewCloseIcon?: boolean; routeTo?: string; routeToExternalLink?: string; linkMessage?: string }): void {
    if (message) {
      this.notification$.next(new NotificationModel({
        message,
        class: 'showNoti',
        viewCloseIcon,
        routeTo,
        routeToExternalLink,
        linkMessage,
        viewNotification: true,
        type: 'danger'
      }));
    }
  }
  /**
   *
   * Show error message that is passed as parameter
   *
   * @memberof MessageHeplerService
   */
  showWarning({ message, viewCloseIcon, routeTo, routeToExternalLink, linkMessage }:
    { message: string; viewCloseIcon?: boolean; routeTo?: string; routeToExternalLink?: string; linkMessage?: string }): void {
    if (message) {
      this.notification$.next(new NotificationModel({
        message,
        class: 'showNoti',
        viewCloseIcon,
        routeTo,
        routeToExternalLink,
        linkMessage,
        viewNotification: true,
        type: 'warning'
      }));
    }
  }

  /**
   *
   *
   * Show error message by passing language key
   *
   * @param labelKey : key of error in lang value
   */
  showErrorByKey(key: string, label: string): void {
    let message = key + '.' + label;
    const traslatedValue = this.uihelper.getTranslation(key, label);
    if (traslatedValue === message) {
      message = 'ERR_CODES.generic';
    }
    this.showError({ message });
  }

  /**
   *
   *
   * Show success message by passing language key
   *
   * @param Key, label : key of error in lang value
   */
  showSuccessByKey(key: string, label: string): void {
    let message = key + '.' + label;
    const traslatedValue = this.uihelper.getTranslation(key, label);
    if (traslatedValue === message) {
      message = 'ERR_CODES.generic';
    }
    this.showSuccess({ message });
  }

  /**
   *
   *
   * close notification
   *
   */
  closeNotification() {
    this.notification$.next(new NotificationModel());
  }
}
